import React from 'react';
import { IRifa } from '../../types/rifa';
import LoadingPage from '../../components/LoadingPage';

interface Props {
	rifa: IRifa,
	loading?: boolean
}

// Mostra as informações do ganhador da rifa
const RifaSorteada: React.FC<Props> = ({ rifa, loading }: Props) => {
	if (loading)
		return <LoadingPage />

   return (
		<section id="ganhador-banner" className="banner-container">
			<div className="overlay" />
			<div className="banner-text-container text-center w-75 mx-auto">
				<div>
					<div>
					<br/><br/>
					<span id="ganhador-title" className="d-block title-lg-common">
						Quem ganhou a rifa {rifa.nomeBeneficiado} foi 
					</span>

					<span id="ganhador-nome" className="d-block title-common">
						{rifa.nomeGanhador ?? ""}
					</span>

					<h5 className="d-block">
						Número {rifa.numeroBilheteGanhador ?? ""}
						<br/><br/>
						Organizador: {rifa.nomeOrganizador}
					</h5>
					<br/><br/>
					</div>
				</div>
			</div>
		</section>
   );
}

export default RifaSorteada;